function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M5 2.6V0L1.875 3.25L5 6.5V3.9C5.99456 3.9 6.94839 4.31089 7.65165 5.04228C8.35491 5.77368 8.75 6.76566 8.75 7.8C8.75 8.83434 8.35491 9.82632 7.65165 10.5577C6.94839 11.2891 5.99456 11.7 5 11.7C4.00544 11.7 3.05161 11.2891 2.34835 10.5577C1.64509 9.82632 1.25 8.83434 1.25 7.8H0C0 9.17913 0.526784 10.5018 1.46447 11.477C2.40215 12.4521 3.67392 13 5 13C6.32608 13 7.59785 12.4521 8.53553 11.477C9.47322 10.5018 10 9.17913 10 7.8C10 6.42087 9.47322 5.09823 8.53553 4.12304C7.59785 3.14786 6.32608 2.6 5 2.6Z",
  fill: "currentColor"
});

var SvgRevert = function SvgRevert(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 10 13",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRevert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/revert.4da4bc30.svg";
export { ForwardRef as ReactComponent };